import { contractGroupRequiresNewSignature, contractGroupSigned, finalizeBasketManually, isContractGroupSigned, selectBasketContractGroups, selectBasketIsFinalized, selectBasketIsPaid, sendBasket } from 'containers/OrderDetails/basketSlice'
import { useReduxDispatch, useReduxSelector } from 'store'
import React, { useEffect, useRef, useState } from 'react'
import useBasketFinalize from 'hooks/useBasketFinalize'
import { Prompt, useHistory } from 'react-router-dom'
import useOrderRedirect from 'hooks/useOrderRedirect'
import useTranslation from 'hooks/useTranslation'
import { Signature } from './SignAgreementPopup'
import { toLongDate } from 'utils/date'
import Contract from './Contract'

const OrderContract: React.FC = () => {
  const contractGroups = useReduxSelector(selectBasketContractGroups)
  const [isLoading, setLoading] = useState(true)
  const isFinalized = useReduxSelector(selectBasketIsFinalized)
  const isPaid = useReduxSelector(selectBasketIsPaid)
  const { t, lang } = useTranslation('contract')

  const contractGroup = contractGroups?.[0]
  const isSigned = isContractGroupSigned(contractGroup)
  const requiresNewSignature = contractGroupRequiresNewSignature(contractGroup)
  const signature = (isSigned && contractGroup?.signature && !Array.isArray(contractGroup.signature)
    ? contractGroup.signature
    : false) as Signature | false

  const date = toLongDate(new Date(), lang, true)

  const dispatch = useReduxDispatch()
  const { finalizeBasket } = useBasketFinalize(setLoading)
  const { push, replace } = useHistory()
  useOrderRedirect()

  const data = useRef({ isPaid, finalizeBasket })
  data.current.isPaid = isPaid
  data.current.finalizeBasket = finalizeBasket

  useEffect(() => {
    let isActive = true
    dispatch(sendBasket({ step: 'contract' })).then((res: any) => {
      if (!isActive) return
      const group = res?.payload?.contractgroups?.[0]
      if (group?.pdf) {
        setLoading(false)
      } else if (group && data.current.isPaid) {
        data.current.finalizeBasket(() => {
          dispatch(finalizeBasketManually(undefined))
        })
      } else {
        replace('/order/payment')
      }
    })
    return () => {
      isActive = false
    }
  }, [dispatch, replace])

  return (
    <>
      <Prompt
        message={({ pathname }) => {
          return isPaid || !signature || pathname.includes('payment') || pathname === '/order/contract' ? true : 'contract'
        }}
      />

      <Contract
        title={<div className='title'>
          <div>{t('rentalAgreement')}</div>
          <div>{t('concludedOn')} <strong>{date}</strong></div>
        </div>}
        isLoading={isLoading}
        outsideCart={!!isFinalized}
        contractGroupId={contractGroup?.id}
        contractPdf={contractGroup?.pdf}
        signature={signature}
        requiresNewSignature={requiresNewSignature}
        signAgreementCallback={(_signature, replacedBy) => {
          dispatch(contractGroupSigned({ id: contractGroup?.id, replacedBy, signature: _signature }))
          if (replacedBy) dispatch(sendBasket({ step: 'contract' }))
        }}
        callback={() => {
          if (isPaid) {
            finalizeBasket(() => {
              dispatch(finalizeBasketManually(undefined))
            })
          } else {
            push('/order/payment')
          }
        }}
      />
    </>
  )
}

export default OrderContract
